/**
 * SFD default properties for various element types.
 * Registered via epxFlow.addDefaultProps().
 */

import { v4 as uuidv4 } from 'uuid';

export const SFD_DEFAULT_PROPS = {
  'epx:UserTask': {
    guid: () => uuidv4(),
    code: '',
    url: '',
  },
  'epx:ServiceTask': {
    guid: () => uuidv4(),
    code: '',
    url: '',
  },
  'epx:ScriptTask': {
    guid: () => uuidv4(),
    code: '',
    url: '',
  },
  'epx:ManualTask': {
    guid: () => uuidv4(),
    code: '',
    url: '',
  },
  'epx:SendTask': {
    guid: () => uuidv4(),
    code: '',
    url: '',
  },
  'epx:ReceiveTask': {
    guid: () => uuidv4(),
    code: '',
    url: '',
  },
  'epx:BusinessRuleTask': {
    guid: () => uuidv4(),
    code: '',
    url: '',
  },
  'epx:CallActivity': {
    guid: () => uuidv4(),
    code: '',
    url: '',
  },
  'epx:SubProcess': {
    guid: () => uuidv4(),
    code: '',
    url: '',
  },
  'epx:StartEvent': {
    guid: () => uuidv4(),
  },
  'epx:EndEvent': {
    guid: () => uuidv4(),
  },
  'epx:ExclusiveGateway': {
    guid: () => uuidv4(),
  },
  'epx:ParallelGateway': {
    guid: () => uuidv4(),
  },
  'epx:InclusiveGateway': {
    guid: () => uuidv4(),
  },
};

/**
 * Resolves default props — calls functions (like guid generators) to produce values.
 */
export function resolveSfdDefaults(defaults) {
  const resolved = {};
  for (const [key, value] of Object.entries(defaults)) {
    resolved[key] = typeof value === 'function' ? value() : value;
  }
  return resolved;
}
